import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { LoadingSpinner } from "../../../general/loading-spinner";
import { emptyProgramMedia, ProgramMedia } from "../../../../interfaces/program";
import { deleteProgramMedia, getProgramMediaSingle } from "../../../../services/program";

interface ProgramMediaDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function ProgramMediaDelete(props: ProgramMediaDeleteProps) {
    const [programMedia, setProgramMedia] = useState<ProgramMedia>(emptyProgramMedia);

    const handleDelete = () => {
        deleteProgramMedia(props.id)
            .then(response => {
                props.onDelete(props.id);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getProgramMediaSingle(props.id)
            .then(response => {
                setProgramMedia(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="program-media-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("Delete media") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { programMedia.id == 0 && 
                    <LoadingSpinner />
                }
                { programMedia.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_program_media_message"
                                values={{
                                    program_media_name: programMedia.name
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}